import { pick } from 'lodash';
export var withStateResetting = function withStateResetting(config) {
  return function (reducer) {
    return function (state, action) {
      var resetOn = config.resetOn,
          keepStateSlices = config.keepStateSlices;

      if (resetOn.includes(action.type)) {
        state = pick(state, keepStateSlices);
      }

      return reducer(state, action);
    };
  };
};